module.exports = __webpack_public_path__ + "media/images/sp/top/hairstyle_header_bg-8e3ed863d88d62aae39192d5ae7a1909.webp";